import React from "react";
import {
  Button,
  NavItem,
  NavLink,
  Nav,
  Container,
  Row,
  Col,
  UncontrolledTooltip,
} from "reactstrap";

const Footer = () => {
  return (
    <footer className="footer has-cards">
      <Container>
        <Row className="row-grid align-items-center my-md">
          <Col lg="6"></Col>
          <Col className="text-lg-center btn-wrapper" lg="6">
            <br /> <br />
          </Col>
        </Row>
        <hr />
        <Row className="align-items-center justify-content-md-between">
          <Col md="6">
            <div className="copyright">© {new Date().getFullYear()}</div>
          </Col>
          <Col md="6">
            <Nav className="nav-footer justify-content-end">
              <NavItem>
                <NavLink href="">Design & Developed by Ghasem Olfat</NavLink>
              </NavItem>
              {/* <NavItem>
                <NavLink
                  href="https://www.creative-tim.com/presentation?ref=adsr-footer"
                  target="_blank"
                >
                  About Us
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  href="http://blog.creative-tim.com?ref=adsr-footer"
                  target="_blank"
                >
                  Blog
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  href="https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md"
                  target="_blank"
                >
                  MIT License
                </NavLink>
              </NavItem> */}
            </Nav>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
